/**
 * Created by andrey on 19.03.2026
 */

class PagesTransportData {
    constructor(options = {}) {
        options.pageSize = options.pageSize || 2048;
        // options.pageSize = options.pageSize || 128;
        options.pagesCount = options.pagesCount || 250;
        options.prefix = options.prefix || "syncpage_";

        this.options = options;

        this.pages = {};
        this.serialized = {};
        this.index = {};
    }

    getPageKey(pageIndex) {
        return this.options.prefix + pageIndex;
    }

    getSessionPageKey() {
        return this.getPageKey(0);
    }

    getAllPagesKeys() {
        return Array.from({ length: this.options.pagesCount }, (_, i) => this.getPageKey(i));
    }

    clearData() {
        const dirty = {};

        for (const pageKey in this.pages) {
            dirty[pageKey] = "";
        }

        this.pages = {};
        this.serialized = {};
        this.index = {};

        return dirty;
    }

    addData(data) {
        data = this.addLongValuesData(data);

        const prevPageKeys = {};

        for (const key in data) {
            const pageKey = prevPageKeys[key] = this.index[key];
            if (pageKey) {
                this.removeValueFromPage(key, pageKey);
            }
        }

        const dirtyPages = new Set(Object.values(prevPageKeys).filter(Boolean));

        for (const [key, value] of Object.entries(data)) {
            const isEmpty = typeof value === "string" && !value || value === undefined;
            if (isEmpty) {
                continue;
            }

            const pageKey = this.findPageToAddValue(key, value, prevPageKeys[key]);
            if (!pageKey) {
                continue;
            }

            this.addValueToPage(key, value, pageKey);

            dirtyPages.add(pageKey);
        }

        const dataToSave = {};

        for (const pageKey of dirtyPages) {
            dataToSave[pageKey] = this.serialized[pageKey];
        }

        return dataToSave;
    }

    setData(data) {
        this.pages = {};
        this.serialized = {};
        this.index = {};

        for (const [pageKey, value] of Object.entries(data)) {
            const parsed = this.parseValue(pageKey, value);

            this.pages[pageKey] = parsed;
            this.serialized[pageKey] = value;

            for (const key in parsed) {
                this.index[key] = pageKey;
            }
        }
    }

    parseResponse(data) {
        let result = {};

        for (const [key, value] of Object.entries(data)) {
            Object.assign(result, this.parseValue(key, value));
        }

        result = this.parseLongValuesResponse(result);
        
        return result;
    }

    removeValueFromPage(key, pageKey) {
        delete this.pages[pageKey][key];
        delete this.index[key];
        this.serialized[pageKey] = JSON.stringify(this.pages[pageKey]);

        if (this.serialized[pageKey] === "{}") {
            this.serialized[pageKey] = "";
        }
    }

    addValueToPage(key, value, pageKey) {
        if (!this.pages[pageKey]) {
            this.pages[pageKey] = {};
        }

        this.pages[pageKey][key] = value;
        this.serialized[pageKey] = JSON.stringify(this.pages[pageKey]);
        this.index[key] = pageKey;
    }

    findPageToAddValue(key, value, prevPageKey) {
        if (key === "session") {
            return this.getSessionPageKey();
        }

        const length = JSON.stringify({ [key]: value }).length;

        const isApplicable = (pageKey) => !this.serialized[pageKey]
            || this.serialized[pageKey].length + length <= this.options.pageSize;

        if (prevPageKey && isApplicable(prevPageKey)) {
            return prevPageKey;
        }

        for (let i = 0; i < this.options.pagesCount; i++) {
            const pageKey = this.getPageKey(i);
            if (isApplicable(pageKey)) {
                return pageKey;
            }
        }

        console.warn(`Can't find page for key ${key}`);
    }

    parseValue(key, value) {
        try {
            const obj = JSON.parse(value);
            if (typeof obj === "object") {
                return obj;
            }
        } catch (e) {
            console.warn(`${key} parseValue ${value}`, e);
        }

        console.warn(`${key} parseValue ${value} - not object`);

        return {};
    }

    addLongValuesData(data) {
        const result = {};

        for (const [key, value] of Object.entries(data)) {
            let serialized = SyncTransportUtils.toString(value);

            const maxLength = this.options.pageSize - key.length - 10;

            if (serialized.length <= maxLength) {
                result[key] = value;
                continue;
            }

            serialized = SyncTransportUtils.toString({ hash: connector.utils.hashCode(serialized), value });

            let partIndex = 0;
            while (serialized.length) {
                result[`${key}#${partIndex}`] = serialized.slice(0, maxLength);
                serialized = serialized.slice(maxLength);
                partIndex++;
            }
        }

        for (const key in data) {
            if (result[key] === undefined) {
                result[key] = "";
            }

            for (let partIndex = 0; partIndex < this.options.pagesCount; partIndex++) {
                const partKey = `${key}#${partIndex}`;
                if (!this.index[partKey] && partIndex > 0) {
                    break;
                }
                if (result[partKey] === undefined) {
                    result[partKey] = "";
                }
            }
        }

        return result;
    }

    parseLongValuesResponse(data) {
        const parseLongValue = (key) => {
            let value = "";

            for (let partIndex = 0; partIndex < this.options.pagesCount; partIndex++) {
                const partKey = `${key}#${partIndex}`;
                if (data[partKey] === undefined) {
                    break;
                }
                value += data[partKey];
            }

            value = SyncTransportUtils.parseValue(value);

            const valueHash = value.hash;
            value = value.value;

            if (value === undefined || valueHash === undefined) {
                return undefined;
            }

            const serialized = SyncTransportUtils.toString(value);
            const hash = connector.utils.hashCode(serialized);

            // eslint-disable-next-line security/detect-possible-timing-attacks
            if (hash !== valueHash) {
                console.warn(`${key} hash mismatch: expected ${valueHash}, got ${hash}`, { value: serialized });
                return undefined;
            }

            return value;
        };

        const result = {};

        const keys = new Set(Object.keys(data)
            .map((key) => key.replace(/#\d+$/, ""))
            .filter(Boolean));

        for (const key of keys) {
            if (data[key] !== undefined) {
                result[key] = data[key];
                continue;
            }

            const value = parseLongValue(key);
            if (value !== undefined) {
                result[key] = value;
            }
        }

        return result;
    }
}